/**
 * @file Input component for select input
 * @author Heino Lenting, Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for the select input component
 */
var InputSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputSelectComponent, _super);
    function InputSelectComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** The value to be displayed. */
        _this.valueLabelKey = '';
        /** List of values and label keys of the options. */
        _this._format = undefined;
        return _this;
    }
    Object.defineProperty(InputSelectComponent.prototype, "format", {
        /** Gets the list of values and label keys of the options. */
        get: function () {
            return this._format;
        },
        /** Sets the options and checks whether the value is one of the options' keys. */
        set: function (value) {
            this._format = value;
            this.valueToLabel();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the value and label key.
     * @param val The key of the selected value.
     */
    InputSelectComponent.prototype.setValue = function (val) {
        _super.prototype.setValue.call(this, val);
        this.valueToLabel();
    };
    /**
     * Sets the display value to the label key based on the value.
     */
    InputSelectComponent.prototype.valueToLabel = function () {
        var _this = this;
        // this.value == null is true when this.value is null or undefined
        if (this.value == null || this.format == null) {
            // Previous check was !this.value... ...but what when this.value is a boolean.
            return;
        }
        var keys = Object.keys(this.format);
        var index = keys.find(function (key) { return _this.format[key].value === _this.value; });
        if (this.format[index]) {
            this.valueLabelKey = this.format[index].labelKey;
        }
    };
    return InputSelectComponent;
}(InputBase));
export { InputSelectComponent };
